module.exports = __webpack_public_path__ + "indicator.svg?4c3aa7ce32cef39ccc2b55c33f30f27f";